import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BeneficiaryAccountTypeResponseDto } from '@app/core/model/beneficiary/beneficiary-account-type.dto';
import { BeneficiaryBankResponseDto } from '@app/core/model/beneficiary/beneficiary-bank.dto';
import { BeneficiaryCreateRequestDto } from '@app/core/model/beneficiary/beneficiary-create.dto';
import { BeneficiaryDocumentTypeResponseDto } from '@app/core/model/beneficiary/beneficiary-document-type.dto';
import { DocumentTypeEnum } from '@app/core/model/common/enums/document-type.enum';
import { BeneficiaryService } from '@app/core/services/beneficiary.service';
import { ExceptionalBeneficiaryService } from '@app/core/services/exceptional-beneficiary.service';
import { NotificationToastrService } from '@app/shared/services/notification-toastr.service';
import { SharedModule } from '@app/shared/shared.module';
import { NgbModal, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { BeneficiaryExceptionalRequestDto } from '@app/core/model/beneficiary-exceptional/beneficiary-exceptional.dto';
import Swal from 'sweetalert2';
import { SmsOtpService } from '@app/core/services/sms-otp.service';
import { GenerateResponseOtpDto } from '@app/core/model/otp-message/generateResponseOtp.dto';
import { ValidateRequestOtpDto } from '@app/core/model/otp-message/validateRequestOtp.dto';
import { switchMap } from 'rxjs';
import { GenericResponseDto } from '@app/core/model/common/generic-response.dto';
import { CreatedChannel } from '@app/shared/enum/created-channel.enum';

@Component({
  selector: 'app-upload-info-exceptional-beneficiary',
  standalone: true,
  imports: [SharedModule, NgbPopoverModule],
  templateUrl: './upload-info-exceptional-beneficiary.component.html',
  styleUrl: './upload-info-exceptional-beneficiary.component.scss'
})
export class UploadInfoExceptionalBeneficiaryComponent implements OnInit{

  @Input() initialData: { dni: string, documentType: any } | null = null;
  @Output() infoSentSuccessfully = new EventEmitter<void>();


    private _beneficiaryService = inject(BeneficiaryService);
    private _notificationToastrService = inject(NotificationToastrService);
    private _exceptionalBeneficiaryService = inject(ExceptionalBeneficiaryService)
    private _smsOtpService = inject(SmsOtpService)
    formUploadUsers: FormGroup;
    documentTypes: BeneficiaryDocumentTypeResponseDto[] = [];
    banks: BeneficiaryBankResponseDto[] = [];
    bankAccountTypes: BeneficiaryAccountTypeResponseDto[] = [];
    responseOtp: GenerateResponseOtpDto;
    public currentDocType: string | null = null;
    private wrongAttempt: number = 0;
    public codigoValido = false;

    
    constructor(private fb: FormBuilder, private sanitizer: DomSanitizer, private serviceModal: NgbModal,) {
      this.formUploadUsers = this.fb.group({
        documentType: [null, Validators.required],
        documentNumber: ['', Validators.required],
        name: ['', Validators.required],
        lastname: ['', Validators.required],
        maternalLastname:['', Validators.required],
        email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-ñÑ]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
        cci: ['', [Validators.required, Validators.pattern(/^\d{20}$/)]],
        bankName: [null, Validators.required],
        accountType: [null, Validators.required],
        numberPhoneUserOTP: ['',[Validators.required, Validators.pattern('^[0-9]{9}$')]],
        otpIsValidate: [false, [Validators.requiredTrue]],
        isAuthorized: [false, Validators.requiredTrue],
        documentTypeDestinatary: [null, Validators.required],
        documentNumberDestinatary: ['', Validators.required],
        nameDestinatary: ['', Validators.required],
        lastnameDestinatary: ['', Validators.required],
        maternalLastnameDestinatary: ['', Validators.required],
      })
    }

    ngOnInit(): void {
      this._beneficiaryService.getDocumentTypes().subscribe(resp => {
        this.documentTypes = resp.data;

        this.patchInitialData();
      })

      this._beneficiaryService.getBanks().subscribe(resp => {
        this.banks = resp.data;
      })

      this._beneficiaryService.getBankAccountTypes().subscribe(resp => {
        this.bankAccountTypes = resp.data;
      })

      this.addInputValidation();
    }

    patchInitialData(): void {
      if(this.initialData && this.initialData.dni && this.initialData.documentType) {

        this._beneficiaryService.getDocumentTypes().subscribe(resp => {
          this.documentTypes = resp.data;

          const matchingDocType = this.documentTypes.find(dt => dt.id === this.initialData.documentType.id);

          this.formUploadUsers.patchValue({
          documentNumber: this.initialData.dni,
          documentType: matchingDocType || null
          })
          this.formUploadUsers.get('documentNumber')?.disable();
          this.formUploadUsers.get('documentType')?.disable();

          this.addInputValidation();
        })
        
      }
    }

    addInputValidation(): void {
      this.formUploadUsers.get('documentTypeDestinatary')?.valueChanges.subscribe((docTypeValue) => {
        console.log('documentType value:', docTypeValue);
        const docNumberControl = this.formUploadUsers.get('documentNumberDestinatary');

        if (!docNumberControl) return;

        // Limpiar validadores previos
        docNumberControl.clearValidators();

        const type = typeof docTypeValue === 'string' ? docTypeValue : docTypeValue?.type;
        this.currentDocType = type?.toUpperCase() || null; // Guardamos el tipo actual

        switch (this.currentDocType) {
          case DocumentTypeEnum.DNI:
            docNumberControl.setValidators([
              Validators.required,
              Validators.pattern(/^\d{8}$/)
            ]);
            break;

          case DocumentTypeEnum.RUC:
            docNumberControl.setValidators([
              Validators.required,
              Validators.pattern(/^\d{11}$/)
            ]);
            break;

          case DocumentTypeEnum.CE:
            docNumberControl.setValidators([
              Validators.required,
              Validators.pattern(/^[a-zA-Z0-9]{9,12}$/)
            ]);
            break;

          case DocumentTypeEnum.PAS:
            docNumberControl.setValidators([
              Validators.required,
              Validators.pattern(/^[a-zA-Z0-9]{6,12}$/)
            ]);
            break;

          default:
            docNumberControl.setValidators(Validators.required);
        }

        docNumberControl.updateValueAndValidity();
      });
    }

    validateDocNumberInput(event: KeyboardEvent): boolean {
      const key = event.key;

      if (this.currentDocType === 'DNI' || this.currentDocType === 'RUC') {
        const isNumber = /^[0-9]$/.test(key);
        if (!isNumber) {
          event.preventDefault();
          return false;
        }
      }

      if (this.currentDocType === 'PAS' || this.currentDocType === 'CE') {
        const isAlphanumeric = /^[a-zA-Z0-9]$/.test(key);
        if (!isAlphanumeric) {
          event.preventDefault();
          return false;
        }
      }

      return true;
    }



      sendUploadUserInformation() {
        Swal.fire({
          title: '¿Estás seguro?',
          text: 'Asegúrate que el CCI ingresado esté al nombre del destinatario. De lo contrario, no recibirás los abonos.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Enviar Información',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            const formData = this.formUploadUsers.getRawValue();

            if (this.formUploadUsers.invalid) {
              this._notificationToastrService.error("Debe registrar los campos obligatorios");
              return;
            }

            const requestCreateDto: BeneficiaryCreateRequestDto = {
              documentTypeId: formData.documentTypeDestinatary?.id,
              documentNumber: formData.documentNumberDestinatary,
              name: formData.nameDestinatary,
              lastname: formData.lastnameDestinatary,
              maternalLastname: formData.maternalLastnameDestinatary,
              email: formData.email,
              bankTypeId: formData.bankName,
              bankAccountTypeId: formData.accountType,
              cci: formData.cci,
              createdChannel: CreatedChannel.PRESENCIAL
            };

            this._beneficiaryService.createBeneficiary(requestCreateDto).pipe(
              switchMap(resp => {
                const newId = resp.data.id;

                const requestUpdateDto: BeneficiaryExceptionalRequestDto = {
                  documentNumber: formData.documentNumber,
                  documentType: formData.documentType?.type,
                  name: formData.name,
                  email: formData.email,
                  paternalLastname: formData.lastname,
                  maternalLastname: formData.maternalLastname,
                  newBeneficiaryId: newId,
                  userId: null,
                };

                console.log('RequestUpdateExceptionalBeneficiary', requestUpdateDto);
                return this._exceptionalBeneficiaryService.updateExceptionalBeneficiary(requestUpdateDto);
              })
            ).subscribe({
              next: () => {
                this.formUploadUsers.reset();
                // Swal.fire('success', '¡Se enviaron los datos correctamente!', 'success');
                this._notificationToastrService.success("¡Se enviaron los datos correctamente!");
                this.infoSentSuccessfully.emit(); // Notificar al padre
              },
              error: (err) => {
                console.error(err);
                const message = err?.error?.status?.message || "Ocurrió un error al enviar los datos";
                Swal.fire({
                  title: 'Registro no autorizado',
                  text: message,
                  icon: 'warning',
                  confirmButtonText: 'Cancelar'
                });
              }
            });
          }
        });
      }


  public async generateOtp() {
  const formData = this.formUploadUsers.value;
  this.wrongAttempt = 0;

  const otpRequest = {
    phone: formData.numberPhoneUserOTP
  };

  try {
    Swal.fire({
      title: 'Enviando código',
      text: `Enviando código a ${formData.numberPhoneUserOTP}`,
      icon: 'success',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const response = await this._smsOtpService.generateOtp(otpRequest);
    this.responseOtp = response.data;
    
    Swal.close();
  } catch (error) {
    console.log('Error completo:', error);
    const mensaje = error?.error?.status?.message || 'No se pudo enviar el código. Intente nuevamente.'
  
    Swal.fire('Error', 'No se pudo enviar el código. Intente nuevamente.', 'error');
    return;
  }

  // Bucle para permitir reintentos sin cerrar la ventana
  while (this.wrongAttempt < 3) {
    const { value: codigo, isConfirmed } = await Swal.fire({
      title: 'Verificación requerida',
      text: `Ingrese el código de confirmación enviado a ${formData.numberPhoneUserOTP}`,
      input: 'text',
      inputPlaceholder: 'Código de 6 dígitos',
      showCancelButton: true,
      confirmButtonText: 'Verificar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (!value) return 'Debe ingresar el código!';
        if (value.length !== 6) return 'El código debe tener 6 dígitos';
        return null;
      }
    });

    if (!isConfirmed) {
      return; // Usuario canceló
    }

    const requestValidate = {
      code: codigo,
      transactionId: this.responseOtp.transactionId
    };

    const codigoValido = await this.verificarCodigo(requestValidate);

    if (codigoValido) {
      return; // Código correcto, salir del bucle
    }

    this.wrongAttempt += 1;
    console.log('Intentos fallidos:', this.wrongAttempt);

    if (this.wrongAttempt === 2) {
      Swal.fire('Atención', 'Cuenta con un último intento, en caso de falla se bloqueará su cuenta por un día.', 'warning');
    } else if (this.wrongAttempt >= 3) {
      Swal.fire('Cuenta bloqueada', 'Ha superado el número de intentos permitidos. Su cuenta ha sido bloqueada por un día.', 'error');
      // return;
    } else {
      Swal.fire('Error', 'Código inválido. Intente nuevamente.', 'error');
    }
  }
  }



   async verificarCodigo(requestDto: ValidateRequestOtpDto): Promise<boolean> {
      try {
        const response = await this._smsOtpService.validateOtp(requestDto);
        console.log('Respuesta validación:', response);

        if (response.data) {
          const control = this.formUploadUsers.get('otpIsValidate');
          control?.setValue(true);  // Ya está habilitado, solo seteas el valor
          control?.markAsTouched(); // Opcional, por si quieres forzar la visualización del estado
          return true;
        }

        return false;

      } catch (error: any) {
        console.error('Error en validación OTP:', error);
        return false;
      }
    }

        SvgPopover = [
          { id: 2,
            class:'popover-secondary only-body',
            content: "Asegúrate que el CCI ingresado esté al nombre del destinatario. De lo contrario no recibirás los abonos.",
            svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>`,
            color: "me-4 svg-secondary",
            textcolor: ''
          },
        ]
      
    getSanitizedSVG(svgContent: string): SafeHtml {
      return this.sanitizer.bypassSecurityTrustHtml(svgContent);
    }

    onlyNumberKey(event: KeyboardEvent): boolean {
    // Permitir solo números del 0 al 9
    const isNumber = /^[0-9]$/.test(event.key);

      if (!isNumber) {
        event.preventDefault();
        return false;
      }
      return true;
    }

}
